module.exports = __webpack_public_path__ + "img/19.f41b0440.jpg";